import { render, staticRenderFns } from "./CalendarSearchModal.vue?vue&type=template&id=1956d5dc&scoped=true&lang=pug&"
import script from "./CalendarSearchModal.vue?vue&type=script&lang=js&"
export * from "./CalendarSearchModal.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSearchModal.vue?vue&type=style&index=0&id=1956d5dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1956d5dc",
  null
  
)

export default component.exports